<template>
  <div class="table-controls">
    <div class="wrapper">
      <div class="d-flex">
        <table-filter-component
          v-show="showFilter"
          @filterClickEvent="filterClickHandler"
        />

        <div class="blank"></div>
        <div class="ml-auto">
          <div class="d-flex">
            <div class="rightArea">
              <table-order-component
                v-show="showOrder"
                :buttons-data="buttonsData"
                @orderClickEvent="orderClickHandler"
              />
              <search-table-component
                @searchChangeEvent="searchChangeHandler"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="tabArea">
      <hp-small-spinner :spinner="spinner" />
      <el-tabs v-show="showFilterArea" class="tabs" type="border-card" stretch>
        <el-tab-pane
          v-for="tab in filterData"
          :label="filterHeader[tab.id]"
          :key="tab.id"
        >
        
          <div v-if="tab.children" >
            <multiselect
              v-model="filterTypes[tab.id]"
              :placeholder=showme()            
              label="name"
              track-by="name"
              :options="tab.children"
              :multiple="true"
              :taggable="false"
              :hide-selected="true"
              :clear-on-select="true"
              @input="multiselectHandler(filterTypes[tab.id], tab.id)"
              @remove="removeSelectionHandler($event)"
            >
            </multiselect>
            </div>
        </el-tab-pane>
      </el-tabs>
    </div>

    <div v-show="showSelectedFilters" class="addedArea">
      <div class="filters">
        <div class="item" v-for="item in selectedFilters" :key="item.key">
          <span class="ellipsis">{{ item.name }}</span>
          <div
            class="filterRemove"
            :id="getFilterRemoveButtonId(item.name)"
            @click="filterRemoveClickHandler($event, item)"
          ></div>
        </div>

        <div
          id="clearAllFilterItemsButton"
          class="filterClear"
          role="button"
          @click="clearAllButtonClickHandler"
        >
          <span class="text">Clear all</span>
          <div class="icon"></div>
        </div>
      </div>
    </div>

    <div v-show="showSelectedFilters" class="countArea">
      <span id="filteredCount" class="bodyStyleN"
        >{{ loading ? "Updating results..." : filteredCount + " results" }}</span
      >
    </div>
  </div>
</template>

<script>
import "../styles/elementsUI.scss";
import TableDto, { Order } from "../js/TableDto.js";
import TableFilterComponent from "./TableFilterComponent.vue";
import TableOrderComponent from "./TableOrderComponent.vue";
import SearchTableComponent from "./SearchTableComponent.vue";
import HpSmallSpinner from "./HpSmallSpinner";
import Vue from "vue";
import { API } from "../js/Constants.js";
import IdNameDTO from "../js/IdNameDTO.js";
import FilterItem from "../js/FilterItem.js";
import EventBus from "../EventBus.js";
import Multiselect from "vue-multiselect";
import ApiSvc from "../js/ApiSvc";
import { ORDER, TABLE } from "../js/Constants.js";
import { Button, Checkbox, Dialog, Loading, TabPane, Tabs } from "element-ui";
import {
  FILTER_CLOSE_EVENT,
  REFRESH_TABLE_CONTROLS_EVENT,
  REFRESH_TABLE_CONTROLS_ORDER_EVENT,
  REFRESH_TABLE_CONTROLS_SEARCH_EVENT,
  TABLE_CONTROLS_CHANGE_EVENT,
} from "../js/event.js";

Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Checkbox);
Vue.use(Button);
Vue.use(Dialog);
Vue.use(Loading);

const SEARCH_QUERY_ID = "query";
const DASHBOARD_FILTER_TYPE = "STATUS";

export default {
  name: "table-controls",
  components: {
    TableFilterComponent,
    TableOrderComponent,
    SearchTableComponent,
    HpSmallSpinner,
    Multiselect,
  },
  props: {
    data: Array,
    defaultSortField: String,
    defaultAscending: Boolean,
    filteredCount: Number,
    loading: { type: Boolean, default: false },
    showFilter: Boolean,
    showOrder: Boolean,
    initialFilters: Array,
  },
  data() {
    return {
      placeHolderFlag: true,
      selectedFilters: [],
      selectedOrder: {},
      showFilterArea: false,
      dialogTableVisible: false,
      loadService: null,
      filtersDataLoaded: false,
      filterData: [],
      dashboardData: [],
      buttonsData: [
        { id: "newest", text: "Newest" },
        { id: "asc", text: "A - Z" },
        { id: "desc", text: "Z - A" },
      ],
      loadingService: null,
      spinner: 0,
      value: [],
      filterTypes: {
        country: [],
        brand: [],
        industryType: [],
        solutionType: [],
        licenseType: [],
      },
      filterHeader: {
        country: "Country",
        brand: "Brand",
        industryType: "Industry type",
        solutionType: "Solution type",
        licenseType: "License type",
      },
    };
  },
  computed: {
    showSelectedFilters() {
      
      return this.selectedFilters.length > 0;
    },
  },
  created() {
    this.selectedOrder = new Order(
      this.defaultSortField,
      this.defaultAscending
    );
    this.selectedFilters =
      this.initialFilters && this.initialFilters.length > 0
        ? this.initialFilters
        : [];
       
  },
  mounted() {
    
     EventBus.$on(REFRESH_TABLE_CONTROLS_EVENT, () => {
      EventBus.$emit(REFRESH_TABLE_CONTROLS_SEARCH_EVENT);
      EventBus.$emit(REFRESH_TABLE_CONTROLS_ORDER_EVENT);
      EventBus.$emit(FILTER_CLOSE_EVENT);
      
       

       if(this.$session.exists("selectedFilterData")){
          const knownFilters = this.$session
            .get("selectedFilterData")
            .filter((item) => item.type === SEARCH_QUERY_ID || this.filterHeader[item.type]);
          this.$session.set("selectedFilterData", knownFilters);
          this.selectedFilters = knownFilters;
       }else{
          this.selectedFilters=[];
       }
       
      
      this.showFilterArea = false;
      
    },);
      
  },
  destroyed() {

    EventBus.$off(REFRESH_TABLE_CONTROLS_EVENT);
   
  },
  watch: {
    selectedFilters() {
       console.log("table control features........................................................"+this.filterData);
      this.updateFilterData(this.filterData);
     
    },
    
  },
  methods: {
    
    showme(){
              if (this.placeHolderFlag === true ) {
                return "Select one or more option";
              } else {
                return "Add more options"
              }
    },
    filterClickHandler(filterIsOpen) {
     
      return new Promise((resolve, reject) => {
        if (filterIsOpen === false) {
          this.spinner--;
        }
        this.showFilterArea = filterIsOpen;
        if (!this.filtersDataLoaded && this.showFilterArea) {
          this.filterData = [...this.data];
          this.spinner++;
          ApiSvc.request(this.data, API.GET)
            .then((res) => {
              const { FilterParam: filters } = res.data;
              this.updateFilterData(filters);
              this.filtersDataLoaded = true;
              this.spinner--;
              resolve();
            })
            .catch(() => {
              this.spinner--;
              reject();
            });
        }
      });
    },
   removeSelectionHandler(filterItem) {  
     this.$session.set("flag-value",false);
      this.selectedFilters = this.selectedFilters.filter(
        (item) => item.key !== filterItem.key
      );
       if (this.filterTypes[filterItem.type]) {
        this.filterTypes[filterItem.type] = this.filterTypes[
          filterItem.type
        ].filter((item) => item.key !== filterItem.key);
      }
      this.selectedFilters = this.selectedFilters.filter(
        (item) => item.key !== filterItem.key
      );
      this.handleTableControlsChangeEvent();
    },
    filterRemoveClickHandler(event, filterItem) {
      this.$session.set("flag-value",false);
      if (this.filterTypes[filterItem.type]) {
        this.filterTypes[filterItem.type] = this.filterTypes[
          filterItem.type
        ].filter((item) => item.key !== filterItem.key);
      }
      this.selectedFilters = this.selectedFilters.filter(
        (item) => item.key !== filterItem.key
      );
      this.$session.set("selectedFilterData", this.selectedFilters);
      this.handleTableControlsChangeEvent();
    },
    clearAllButtonClickHandler() {
      this.selectedFilters = [];
      for (let key in this.filterTypes) {
        this.filterTypes[key] = [];
      }

      this.placeHolderFlag = true;
      this.$session.remove("data");
      this.$session.remove("selectedFilterData");
      this.$session.remove("global");
     this.handleTableControlsChangeEvent();
    },
    addFilter(filterTypeId, filter) {
      this.$session.set("flag-value",false);
      if (Array.isArray(filter)) {
        console.log("inside add filter"+JSON.stringify(filter));
        for (let i = 0; i < filter.length; i++) {
          const filterHash = this.generateFilterKey(
            filterTypeId,
            filter[i].type
          );
          const currentFilterType = filterTypeId;
          const isFilterUnique = this.selectedFilters.every(
            (item) => item.key !== filterHash
          );

          if (isFilterUnique) {
            let filterName = filter[i].type;
            if (filterTypeId !== SEARCH_QUERY_ID) {
              filterName = filter[i].name;
            }
            this.selectedFilters.push(
              new FilterItem(
                filter[i].type,
                currentFilterType,
                filterName,
                filterHash
              )
            );
            this.$session.set("selectedFilterData", this.selectedFilters);
            this.handleTableControlsChangeEvent();
          }
        }
      } else {
        const filterHash = this.generateFilterKey(filterTypeId, filter.id);
        const currentFilterType = filterTypeId;
        const isFilterUnique = this.selectedFilters.every(
          (item) => item.key !== filterHash
        );

        if (isFilterUnique) {
          let filterName = filter.id;
          if (filterTypeId !== SEARCH_QUERY_ID) {
            filterName = filter.name;
          }
          this.selectedFilters.push(
            new FilterItem(filter.id, currentFilterType, filterName, filterHash)
          );
          this.handleTableControlsChangeEvent();

        }
      }
    },
    multiselectHandler(value, idType) {
      this.placeHolderFlag =false;
      
      this.addFilter(idType, value);
      //this.$session.set("selectedFilterData", this.selectedFilters);
      this.$session.set("selectedFilterData-flag", false);
     //this.$session.set("data", this.filterData);
      this.$session.set("flag-value",false);
      
    },
    searchChangeHandler(searchText) {
      this.addFilter(SEARCH_QUERY_ID, new IdNameDTO(searchText, searchText));
      EventBus.$emit(REFRESH_TABLE_CONTROLS_SEARCH_EVENT);
      this.showFilterArea = false;
    },
    handleTableControlsChangeEvent() {
      const data = new TableDto();
      data.query = this.selectedFilters
        .filter((item) => item.type === SEARCH_QUERY_ID)
        .map((item) => item.name);

      const filtersMap = {};
      this.dashboardData = this.selectedFilters.filter(
        (item) => item.type === DASHBOARD_FILTER_TYPE
      );

      this.selectedFilters
        .filter((item) => item.type !== SEARCH_QUERY_ID)
        .forEach((item) => {
          if (Object.prototype.hasOwnProperty.call(filtersMap, item.type)) {
            filtersMap[item.type].push(item.id);
          } else {
            filtersMap[item.type] = [item.id];
          }
        });
      data.filter = filtersMap;
      data.order = Object.keys(this.selectedOrder).length
        ? this.selectedOrder
        : new Order(this.defaultSortField, this.defaultAscending);
      this.$emit(TABLE_CONTROLS_CHANGE_EVENT, data);
 
     
    },
    generateFilterKey(typeId, filterId) {
      return `${typeId}${filterId}`;
    },
    orderClickHandler(id) {
     // this.$session.set("flag-value",false);

     

      let propertyName = this.defaultSortField;
      let ascending = this.defaultAscending;
      switch (id) {
        case ORDER.ASC:
          propertyName = TABLE.FIELD_NAME.COMMON.NAME;
          ascending = true;
          break;
        case ORDER.DESC:
          propertyName = TABLE.FIELD_NAME.COMMON.NAME;
          ascending = false;
          break;
        case ORDER.NEWEST:
          propertyName = TABLE.FIELD_NAME.APP.LAST_UPDATE_TIME;
          ascending = false;
          break;
      }
      this.selectedOrder = new Order(propertyName, ascending);
      this.handleTableControlsChangeEvent();
    },
    getFilterRemoveButtonId(itemName) {
      return `${itemName}FilterRemoveButton`;
    },
    updateFilterData(filterData) {
      this.filterData = filterData.map((item) => {
        const currentFilter = Object.assign({}, item);
        if (currentFilter.children) {
          currentFilter.children = [
            ...currentFilter.children.map((child) => {
              const childElement = Object.assign({}, child);
              childElement.key = this.generateFilterKey(
                item.id,
                childElement.type
              );
              const isFilterSelected =
                this.selectedFilters.filter(
                  (filter) =>
                    filter.type === item.id && filter.id === childElement.type
                ).length === 1;
              childElement.value = isFilterSelected;
              
              return childElement;
            }),
          ];
        }
        const filterList = currentFilter.children;
        const othersIdx = filterList.findIndex((obj) => obj.type === "Others");
        if (othersIdx !== -1) {
          const othersObj = filterList.splice(othersIdx, 1)[0];
          filterList.push(othersObj);
        }
        return currentFilter;
      });
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped lang="scss">
@import "../styles/hpConstant.scss";
@import "../styles/hpCommon.scss";
@import "../styles/hpMixin.scss";

.table-controls {
  width: 100%;
  margin-bottom: 20px;
  .wrapper {
    min-height: 50px;
    border-bottom: 2px solid $hpPrimary;

    .blank {
      flex: 1;
    }

    .rightArea {
      display: flex;
    }
  }

  .tabArea {
    position: relative;
    width: 100%;
    height: available;

    /deep/ .vld-overlay.is-active {
      background: $hpWhite;
    }

    .tabs {
      // min-height: 116px;

      .tab {
        width: 21%;
        padding-bottom: 12px;
        padding-right: 5px;
      }

      .tab:nth-child(4n + 5) {
        margin-left: 0 !important;
      }

      .tab:only-child {
        width: 50%;
      }

      /deep/.filter-tabs__tab {
        width: 21%;
        padding-bottom: 12px;
        padding-right: 5px;
      }

   

      /deep/ .el-tabs__content {
        text-align: left;
        padding: 24px 20px 15px !important;
        height: 190px;
        overflow: scroll !important;
        color: $hpBlack;
        z-index: 1 !important;
      }

      /deep/ .multiselect__tags {
        // min-height: 10px;
        border: 1px solid $hpPrimary !important;
        
      }
      
      /deep/ .multiselect__content-wrapper {
        // min-height: 10px;
        bottom: auto;
        width: 100%;
        height: 100px;
      }

    }
  }

  .addedArea {
    display: flex;
    flex-wrap: nowrap;
    justify-content: right;
    right: 0;
    min-height: 40px;

    .filters {
      width: 100%;
      min-height: 40px;
      padding: 0 100px 0 15px;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      position: relative;

      .item {
        font-size: 14px;
        display: flex;
        flex-direction: row;
        align-items: center;
        flex-wrap: nowrap;
        margin: 10px 15px;

        .filterRemove {
          width: 14px;
          height: 14px;
          margin-left: 5px;
          background-image: url("../assets/images/icons/filter_remove.png");
          background-position: top center;
          display: inline-block;
          cursor: pointer;
          vertical-align: middle;
          flex-shrink: 0;
        }
      }

      .filterClear {
        position: absolute;
        right: 20px;
        bottom: 12px;
        height: 20px;
        vertical-align: middle;
        cursor: pointer;
        color: $hpPrimary;

        .notices {
          bottom: 13px;
          height: 14px;
        }

        .text {
          font-size: 14px;
        }
        .text:hover {
          color: $hpPrimaryHover;
        }

        .icon {
          margin-left: 5px;
          margin-bottom: 3px;
          vertical-align: middle;
          width: 14px;
          height: 14px;
          display: inline-block;
          background-image: url("../assets/images/icons/filter_clear_nor.png");
        }
        .icon:hover {
          background-image: url("../assets/images/icons/filter_clear_pre.png");
        }
      }
    }
  }

  .countArea {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 32px;
    padding-top: 20px;
    padding-left: 20px;
  }
  
}

</style>
